import {Injectable} from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Router } from '@angular/router';
import { SocketService } from '../services/socket.service';
import { AccountService } from '../services/account.service';
import { Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TokenStorageService } from '../services/helpers/token.service';
import { AuthService } from '../services/auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private accountService: AccountService,
              private socketService: SocketService,
              private tokenService: TokenStorageService,
              private authService: AuthService,
              private toastrService: ToastrService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cloneRequest = request.clone({
      headers: request.headers.set('authorization', 'Bearer ' + this.tokenService.getToken())
    });
    return next.handle(cloneRequest)
      .pipe(catchError((err) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 401) {
              if (cloneRequest.url.includes('refresh_access_token')) {
                this.logout();
              } else if (cloneRequest.url.includes('logout')) {
                localStorage.clear();
                sessionStorage.clear();
                this.router.navigate(['auth/login']);
              } else {
                return this.handle401Error(cloneRequest, next);
              }
            } else if (err.status === 422) {
              for (const key of Object.keys(err.error.errors)) {
                this.toastrService.error(err.error.errors[key]);
              }
            } else {
              if (cloneRequest.url.includes('refresh_access_token')) {
                this.logout();
              } else {
                console.log(err)
                this.toastrService.error(err?.error?.message);
              }
            }
          }
          return throwError(err);
        })

      );
  }

  logout() {
    const user = this.accountService.getAccount();
    localStorage.clear();
    sessionStorage.clear();
    if (user) {
      this.socketService.unSubscribe(user.id);
    }
    this.authService.logout().subscribe();
    this.router.navigate(['auth/login']);
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    const token = this.tokenService.getToken();
    if (token) {
      return this.authService.refreshToken().pipe(
        switchMap((data: any) => {
          const modified = request.clone({
            setHeaders: { authorization: 'Bearer ' + data.token.access_token }
          });
          console.log(modified, 'modified')
          return next.handle(modified);
        }),
        catchError((err) => {
          return throwError(err);
        })
      );
    } else {
      const user = this.accountService.getAccount();
      if (user) {
        this.socketService.unSubscribe(user.id);
      }
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['auth/login']);
    }
  }
}
